/**
 * @generated SignedSource<<b95154fe01b0b317029252539bb6901e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityScreenQuery$variables = {
  departmentSlug: string;
};
export type DepartmentAvailabilityScreenQuery$data = {
  readonly department: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CourseList_department" | "DepartmentAvailabilityHeaderFragment_department" | "DepartmentAvailabilitySidebarFragment_department">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityHeaderFragment_session" | "DepartmentAvailabilitySidebar_session">;
  } | null | undefined;
};
export type DepartmentAvailabilityScreenQuery = {
  response: DepartmentAvailabilityScreenQuery$data;
  variables: DepartmentAvailabilityScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "departmentSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "departmentSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  (v2/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v12 = {
  "kind": "Literal",
  "name": "archived",
  "value": false
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DepartmentAvailabilityScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartmentAvailabilityHeaderFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartmentAvailabilitySidebar_session"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Department",
        "kind": "LinkedField",
        "name": "department",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CourseList_department"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartmentAvailabilityHeaderFragment_department"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartmentAvailabilitySidebarFragment_department"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DepartmentAvailabilityScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportsPublic",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v2/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v9/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Department",
        "kind": "LinkedField",
        "name": "department",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarStartDay",
                "storageKey": null
              },
              (v2/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "logoImage",
                "plural": false,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityConnection",
            "kind": "LinkedField",
            "name": "facilities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publicBookingWindowDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "memberBookingWindowDays",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityStartEndTime",
                        "kind": "LinkedField",
                        "name": "startEndTime",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTime",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "singular",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plural",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "bookingType",
                            "value": "STANDARD"
                          }
                        ],
                        "concreteType": "GroupSize",
                        "kind": "LinkedField",
                        "name": "minMaxGroupSize",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "min",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "max",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": (v13/*: any*/),
                        "concreteType": "CourseConnection",
                        "kind": "LinkedField",
                        "name": "courses",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "courses(archived:false)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "facilityType",
                "value": "GOLF_COURSE"
              }
            ],
            "concreteType": "CourseConnection",
            "kind": "LinkedField",
            "name": "courses",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": (v13/*: any*/),
                            "concreteType": "CourseConnection",
                            "kind": "LinkedField",
                            "name": "courses",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/)
                            ],
                            "storageKey": "courses(archived:false)"
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "courseImage",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "courses(archived:false,facilityType:\"GOLF_COURSE\")"
          },
          (v4/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d01378e280482cc311038d6d12ee4f53",
    "id": null,
    "metadata": {},
    "name": "DepartmentAvailabilityScreenQuery",
    "operationKind": "query",
    "text": "query DepartmentAvailabilityScreenQuery(\n  $departmentSlug: String!\n) {\n  session {\n    ...DepartmentAvailabilityHeaderFragment_session\n    ...DepartmentAvailabilitySidebar_session\n  }\n  department(slug: $departmentSlug) {\n    id\n    ...CourseList_department\n    ...DepartmentAvailabilityHeaderFragment_department\n    ...DepartmentAvailabilitySidebarFragment_department\n  }\n}\n\nfragment CourseCardCourseNote_course on Course {\n  facility {\n    id\n  }\n}\n\nfragment CourseCardSummary_course on Course {\n  id\n  facility {\n    id\n    slug\n  }\n}\n\nfragment CourseCard_course on Course {\n  ...useCourseDisplayName_course\n  ...CourseCardSummary_course\n  ...CourseCardCourseNote_course\n  description\n  courseImage {\n    publicId: renderingKey\n  }\n  facility {\n    address\n    id\n  }\n}\n\nfragment CourseList_department on Department {\n  id\n  club {\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n  ...useDepartmentMaxGolfCourseBookingWindow_department\n  courses(facilityType: GOLF_COURSE, archived: false) {\n    edges {\n      node {\n        id\n        name\n        facility {\n          name\n          id\n        }\n        ...CourseCard_course\n      }\n    }\n  }\n}\n\nfragment DepartmentAvailabilityCoursePicker_department on Department {\n  id\n  facilities {\n    edges {\n      node {\n        type\n        copyOverrides {\n          course {\n            plural\n          }\n        }\n        ...DepartmentAvailabilityCoursePicker_facilityToCourseOption\n        id\n      }\n    }\n  }\n}\n\nfragment DepartmentAvailabilityCoursePicker_facilityToCourseOption on Facility {\n  name\n  courses(archived: false) {\n    count\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment DepartmentAvailabilityDatePicker_department on Department {\n  ...useDepartmentMaxGolfCourseBookingWindow_department\n  club {\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment DepartmentAvailabilityFiltersModal_department on Department {\n  ...DepartmentAvailabilityTimeSliderFragment_department\n  ...DepartmentAvailabilityGroupSizeSelect_department\n  ...DepartmentAvailabilityCoursePicker_department\n  ...departmentToScheduleOption_department\n}\n\nfragment DepartmentAvailabilityFiltersModal_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment DepartmentAvailabilityGroupSizeSelect_department on Department {\n  ...useDepartmentGolfFacilitiesGroupSize_department\n}\n\nfragment DepartmentAvailabilityHeaderFragment_department on Department {\n  ...useGetDepartmentAvailabilityFilterBarValues_department\n  ...DepartmentAvailabilityFiltersModal_department\n  club {\n    name\n    ...FacilityLogoFragment_club\n    id\n  }\n}\n\nfragment DepartmentAvailabilityHeaderFragment_session on Session {\n  ...DepartmentAvailabilityFiltersModal_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment DepartmentAvailabilitySidebarFragment_department on Department {\n  ...DepartmentAvailabilityTimeSliderFragment_department\n  ...DepartmentAvailabilityGroupSizeSelect_department\n  ...departmentToScheduleOption_department\n  ...DepartmentAvailabilityDatePicker_department\n  ...DepartmentAvailabilityCoursePicker_department\n}\n\nfragment DepartmentAvailabilitySidebar_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment DepartmentAvailabilityTimeSliderFragment_department on Department {\n  ...useDepartmentGolfFacilitiesStartEndTime_department\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useCourseDisplayName_course on Course {\n  name\n  facility {\n    name\n    courses(archived: false) {\n      count\n    }\n    id\n  }\n}\n\nfragment useDepartmentGolfFacilitiesGroupSize_department on Department {\n  facilities {\n    edges {\n      node {\n        type\n        minMaxGroupSize(bookingType: STANDARD) {\n          min\n          max\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useDepartmentGolfFacilitiesStartEndTime_department on Department {\n  facilities {\n    edges {\n      node {\n        type\n        startEndTime {\n          startTime\n          endTime\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useDepartmentMaxGolfCourseBookingWindow_department on Department {\n  facilities {\n    edges {\n      node {\n        id\n        type\n        publicBookingWindowDays\n        memberBookingWindowDays\n        club {\n          supportsPrivate\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetDepartmentAvailabilityFilterBarValues_department on Department {\n  ...useDepartmentGolfFacilitiesStartEndTime_department\n  facilities {\n    edges {\n      node {\n        type\n        copyOverrides {\n          course {\n            singular\n            plural\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "beb9bad2b625495e366c7afca7a9bd47";

export default node;
